import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=284e6bea&"
import script from "./SessionDetails.vue?vue&type=script&lang=js&"
export * from "./SessionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports